import React, { useContext, useEffect, useState } from 'react';
import ProjectContainer from '../../components/containers/ProjectContainer';
import { Components } from './styled';
import ProjectTableHeader from '../../components/ProjectTableHeader';
import useFormTextState from '../../hooks/useFormTextState';
import ProjectTable from '../../components/ProjectTable';
import { filteringModel, tableColumns } from '../../components/ProjectTable/constants';
import { ActivityIndicatorContext } from '../../providers/ActivityIndicatorProvider/context';
import useModalState from '../../hooks/useModalState';
import { Network } from '../../api/types/network';
import { deleteNetwork, getAllNetworks } from '../../api/network';
import CreateOrEditNetworkModal from '../../components/modals/CreateOrEditNetworkModal';

const Networks = () => {
  const { setIsLoading } = useContext(ActivityIndicatorContext);

  const [data, setData] = useState<Network[]>([]);

  const searchProps = useFormTextState();

  const createNetworkModalProps = useModalState<{ network?: Network }>();

  const refreshData = async () => {
    setIsLoading(true);
    const result = await getAllNetworks();
    setIsLoading(false);

    if (result && Array.isArray(result)) {
      setData(result);
    }
  };

  useEffect(() => {
    refreshData().then();
  }, []);

  const onAddNetwork = () => {
    createNetworkModalProps.open({});
  };

  const onEditNetwork = (id: string) => {
    const network = data?.find((item) => item?.id === id);

    if (network) {
      createNetworkModalProps.open({ network });
    }
  };

  const onDeleteNetwork = async (id: string) => {
    setIsLoading(true);
    await deleteNetwork(id);
    setIsLoading(false);
    await refreshData();
  };

  const onCreateOrEditModalClose = (refreshTrigger?: boolean) => {
    if (refreshTrigger) {
      refreshData?.().then();
    }

    createNetworkModalProps.onModalClose();
  };

  const _filteringModel = filteringModel([
    { columnField: 'name', value: searchProps.value, operatorValue: 'contains' },
  ]);

  return (
    <ProjectContainer title={'Default Networks'}>
      <Components.Container>
        <ProjectTableHeader
          onSearchChange={searchProps.onChangeText}
          searchLabel={'Search by network name or ID'}
          searchPlaceholder={'Enter search term'}>
          <Components.SearchBarSeparator />
          <Components.PrimaryButton onClick={onAddNetwork}>Add Network</Components.PrimaryButton>
        </ProjectTableHeader>
        <Components.TableWrapper>
          <ProjectTable
            data={data || []}
            columns={tableColumns.networks({ onEdit: onEditNetwork, onDelete: onDeleteNetwork })}
            filteringModel={_filteringModel}
            sortingModel={{ field: 'name', sort: 'asc' }}
          />
        </Components.TableWrapper>
      </Components.Container>
      <CreateOrEditNetworkModal
        {...createNetworkModalProps}
        onModalClose={onCreateOrEditModalClose}
        refreshCallback={refreshData}
      />
    </ProjectContainer>
  );
};

export default Networks;
